import { useEffect, useState } from 'react';

type Countdown = {
  hh: number;
  mm: number;
  ss: number;
};

export function useCountdown(initialSeconds: number): Countdown {
  const [seconds, setSeconds] = useState(initialSeconds);

  useEffect(() => {
    const id = setInterval(() => setSeconds((s) => (s > 0 ? s - 1 : 0)), 1000);
    return () => clearInterval(id);
  }, []);

  return {
    hh: Math.floor(seconds / 3600),
    mm: Math.floor((seconds % 3600) / 60),
    ss: seconds % 60,
  };
}
